// previousDayWinners.jsx
import React from "react";
import UserFace from "../../../assets/img/avatar-face.jpg";
import constants from "../../../utilities/constants.json";
import { Link } from "react-router-dom";
import "./previousDayWinners.css";
import "react-toastify/dist/ReactToastify.css";
import { Button, Dialog, Slide } from "@mui/material";
import { formatLabel } from "../../../utilities/string";

const imageUrl = constants.profile_image;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviousDayWinners = (prop) => {

  const [loginModalVisible,setLoginModalVisible] = React.useState(false);

  const handlePleaseLoginClose = () => {
    setLoginModalVisible(false);
  }

  const openLoginModal = () => {
    setLoginModalVisible(true);
  }

  return (
    <div className="previousDayWinners">
      <div className="previousDayWinners-wrapper">
        <div className="previousDayWinners-topSection">
          <div className="previousDayWinners-title-wrapper">
            <h5>{formatLabel(prop?.question?.group_label??"")} Winner</h5>
            {/* <span className="previousDayWinners-date">20 - 21 Jun</span> */}
          </div>
        </div>

        <div className="previousDayWinners-middleSection">
          <div className="previousDayWinners-middle-wrapper">
            {prop.leaderboard ? (
              prop.leaderboard.map((winners, index) => (
                <div className="previousDayWinners-playerOne" key={index}>
                  <div className="playerImg">
                    <img
                      src={winners.image ? imageUrl + winners.image : UserFace}
                      alt=""
                      onError={(e) =>
                          (e.target.onerror = null)(
                              (e.target.src = UserFace)
                          )}
                    />
                  </div>
                  <p className="playerName">{winners.name}</p>
                  <p className="playerPoints">{winners.score} Pts</p>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>

        {/* Engaging login prompt for non-logged in users */}
          <div className="previousDayWinners-engageSection">
            <div className="engageSection-content">
              <div className="engageSection-icon">🏆</div>
              <h6 className="engageSection-title">Could this be you?</h6>
              <p className="engageSection-description">
                Join thousands of players competing daily. Make your predictions and climb the leaderboard!
              </p>
              <div onClick={openLoginModal} className="engageSection-button">
                Start Playing Now
              </div>
            </div>
          </div>

        <div className="previousDayWinners-bottomSection">
          <div className="previousDayWinners-bottom-wrapper">
            <div className="previousDayWinners-divider"></div>
            <Link to='/mobile-leaderboard'>
              <p className="previousDayWinners-leaderboard">View Leaderboard</p>
            </Link>
          </div>
        </div>
      </div>
      <div className="pleaseLoginModal">
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          PLEASE LOG IN
        </Button> */}
        <Dialog
          open={loginModalVisible}
          TransitionComponent={Transition}
          keepMounted
          onClose={handlePleaseLoginClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="pleaseLoginModal-wrapper">
            <div className="pleaseLoginModal-header">
              <h2>Not Logged In!</h2>
            </div>
            <div className="pleaseLoginModal-content">
              <p>Please login/register to start predicting.</p>
            </div>

            <div className="pleaseLoginModal-button-wrapper">
              <Link to="/mobile-login">
                <Button className="pleaseLoginModal-login-btn">LOGIN</Button>
              </Link>
              <Link to="/mobile-register">
                <Button className="pleaseLoginModal-register-btn">
                  REGISTER
                </Button>
              </Link>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default PreviousDayWinners;